/* L-Carnitine + Pryme stack pages (sections/ls-*.liquid): buy box (options, flavours, subscribe, gallery, add to cart),
   sticky bar, review filters and video play buttons. The selected option is data-ls-tier on <html> and an unticked
   subscribe box puts .ls-once on <html>; ls.css shows the matching prices, gifts and button text (all rendered by
   Liquid, so the currency app converts them). */
(function () {
  var html = document.documentElement;

  function initOffer(root) {
    if (root.getAttribute('data-ls-ready')) return;
    root.setAttribute('data-ls-ready', '1');

    var tiers = root.querySelectorAll('[data-ls-tier]');
    var flavours = root.querySelectorAll('[data-ls-flavour]');
    var sub = root.querySelector('[data-ls-sub]');
    var btn = root.querySelector('[data-ls-atc]');
    var errorEl = root.querySelector('[data-ls-error]');
    var cfgEl = root.querySelector('[data-ls-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;

    /* Flavour dropdowns with photos: the real <select> stays hidden and keeps the value */
    root.querySelectorAll('select[data-ls-img-select]').forEach(function (sel) {
      var wrap = document.createElement('div');
      wrap.className = 'ls-fs';
      sel.parentNode.insertBefore(wrap, sel);
      wrap.appendChild(sel);
      sel.tabIndex = -1;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ls-fs__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', sel.getAttribute('aria-label') || '');
      var list = document.createElement('div');
      list.className = 'ls-fs__list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      function row(el, o) {
        el.textContent = '';
        var img = o.getAttribute('data-img');
        if (img) { var i = document.createElement('img'); i.src = img; i.alt = ''; el.appendChild(i); }
        var t = document.createElement('span'); t.textContent = o.textContent; el.appendChild(t);
      }
      function close() { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
      Array.prototype.forEach.call(sel.options, function (o) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'ls-fs__opt';
        opt.setAttribute('role', 'option');
        opt.disabled = o.disabled;
        row(opt, o);
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          sel.value = o.value;
          row(btn, o);
          list.querySelectorAll('.ls-fs__opt').forEach(function (x) { x.setAttribute('aria-selected', String(x === opt)); });
          close();
          btn.focus();
        });
        opt.setAttribute('aria-selected', String(o.selected));
        list.appendChild(opt);
      });
      row(btn, sel.options[sel.selectedIndex]);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = list.hidden;
        root.querySelectorAll('.ls-fs__list').forEach(function (l) { l.hidden = true; });
        list.hidden = !opening;
        btn.setAttribute('aria-expanded', String(opening));
      });
      wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); btn.focus(); } });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      wrap.appendChild(btn);
      wrap.appendChild(list);
    });

    function showError(msg) { if (errorEl) errorEl.textContent = msg || ''; }
    function count() { return parseInt(html.getAttribute('data-ls-tier'), 10) || 1; }

    function selectTier(n) {
      html.setAttribute('data-ls-tier', String(n));
      tiers.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-ls-tier') === String(n))); });
      flavours.forEach(function (sel) {
        var label = sel.closest('label');
        if (label) label.hidden = parseInt(sel.getAttribute('data-ls-flavour'), 10) > n;
      });
      root.querySelectorAll('[data-ls-stack-label]').forEach(function (l) { l.hidden = n < 2; });
      showError('');
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(parseInt(t.getAttribute('data-ls-tier'), 10)); });
    });
    /* A funnel page (sections/pa-flow.liquid) passes the stack chosen there */
    var fromUrl = parseInt(new URLSearchParams(window.location.search).get('stack'), 10);
    if (fromUrl && root.querySelector('[data-ls-tier="' + fromUrl + '"]')) selectTier(fromUrl);
    if (sub) sub.addEventListener('change', function () { html.classList.toggle('ls-once', !sub.checked); });

    /* Gallery: thumbnails swap the main frame */
    var slides = root.querySelectorAll('[data-ls-slide]');
    var thumbs = root.querySelectorAll('[data-ls-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var n = t.getAttribute('data-ls-thumb');
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-ls-slide') !== n; });
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
      });
    });

    function lines() {
      var n = count();
      var counts = {};
      var order = [];
      for (var i = 0; i < n; i++) {
        var id = flavours[i] ? flavours[i].value : String(cfg.variant);
        if (!counts[id]) { counts[id] = 0; order.push(id); }
        counts[id] += 1;
      }
      var subscribed = !!(sub && sub.checked);
      return order.map(function (id) {
        var item = { id: parseInt(id, 10), quantity: counts[id] };
        if (subscribed && cfg.plan) item.selling_plan = cfg.plan;
        /* Gift set: jx-gifts.js adds that set's gifts for bottles tagged this way */
        if (subscribed && cfg.plan && cfg.giftTrack) item.properties = { _jx_gift_track: cfg.giftTrack, _jx_no_bonus: '1' };
        return item;
      });
    }

    if (btn && cfg) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        if (!cfg.variant || !cfg.available) { showError(cfg.errors.unavailable); return; }
        var items = lines();
        showError('');
        btn.setAttribute('aria-disabled', 'true');
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (x) { return x.id; });
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        var canPublish = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
        var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              showError(res.description || res.message || cfg.errors.generic);
              if (canPublish) publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: items[0].id, errors: res.errors || res.description, message: res.message });
              return;
            }
            if (!cart || typeof cart.renderContents !== 'function') {
              window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              return;
            }
            /* jx-gifts.js listens for this and adds the free gifts the subscription bundles earn */
            if (canPublish) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: res });
            cart.renderContents(res);
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(function (e) { console.error(e); showError(cfg.errors.generic); })
          .finally(function () { btn.removeAttribute('aria-disabled'); });
      });
    }
  }

  /* Sticky bar: on once the visitor is past the first screen, off while the buy box is visible */
  function initSticky(bar) {
    if (bar.getAttribute('data-ls-ready')) return;
    bar.setAttribute('data-ls-ready', '1');
    var offer = document.getElementById('offer');
    var offerVisible = false;
    function update() { bar.classList.toggle('is-on', window.scrollY > window.innerHeight * 0.6 && !offerVisible); }
    if (offer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        offerVisible = entries[0].isIntersecting;
        update();
      }).observe(offer);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initReviews(root) {
    if (root.getAttribute('data-ls-ready')) return;
    root.setAttribute('data-ls-ready', '1');
    var chips = root.querySelectorAll('[data-ls-filter]');
    var cards = root.querySelectorAll('[data-ls-topic]');
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-ls-filter');
        chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
        cards.forEach(function (card) { card.hidden = !!f && card.getAttribute('data-ls-topic') !== f; });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ls-offer]').forEach(initOffer);
    document.querySelectorAll('[data-ls-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-ls-reviews]').forEach(initReviews);
  }

  /* Video play buttons (delegated, so it works for sections loaded later) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ls-play]');
    if (!b) return;
    var wrap = b.closest('.ls-video');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;
    video.controls = true;
    wrap.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () { /* autoplay blocked: controls are visible now */ });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
